import { Component, Input, OnInit } from '@angular/core';
import { Sotto100Service } from '../../../core/services/tables/sotto100.service';
import { InfoService } from '../../../core/services/tables-info/info.service';
import { VwLabSotto100 } from 'src/app/models/vwLabSotto100';
import { DialogService } from 'src/app/core/services/dialog.service';
import { DataStatus } from 'src/app/models/Helpers/data-status';
import { Loader } from 'src/app/models/Helpers/loader';
import {animate, transition, trigger, state, style} from '@angular/animations';
import {AddToWatchlistManagerService} from '../../../core/services/watchlists/add-to-watchlist-manager.service';

@Component({
  selector: 'app-sotto100-table',
  templateUrl: './sotto100-table.component.html',
  styleUrls: ['./sotto100-table.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: 0, padding: 0 })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('0.3s cubic-bezier(0.77, 0, 0.175, 1)'))
    ]),
  ]
})
export class Sotto100TableComponent implements OnInit {

  @Input() userRole: string;

  TABLE_TITLE = 'Sotto 100';
  VIEW_ALL_PATH = '/menu/sotto-100';
  TABLE_SORT_HEADERS: Array<[string, string]> = [
    ['Isin', 'Isin'],
    ['Emittente', 'Emittente'],
    ['Nome', 'Nome'],
    ['Scadenza', 'Scadenza'],
    ['Divisa', 'Divisa'],
    ['Ask', 'Prezzo'],
    ['Rimborso', 'Rimborso'],
    ['RendimentoAssoluto', 'Rend. Assoluto'],
    ['RendimentoAnnuo', 'Rend. Annuo'],
    ['Mercato', 'Mercato']
  ];
  tableInfoExists: boolean;

  records: VwLabSotto100[];
  dataStatus = new DataStatus();
  loader = new Loader();

  sortingFilter: string;
  sortingAscending: boolean;

  downloadExcelLoader = new Loader();

  userIsAdmin: boolean;
  userIsProfessional: boolean;

  state = 'collapsed';

  constructor(
    private service: Sotto100Service,
    private infoService: InfoService,
    private dialogService: DialogService,
    private addToWatchlistManager: AddToWatchlistManagerService
  ) { }


  ngOnInit(): void {
    this.userIsAdmin = this.userRole === 'CedLabAdmin';
    this.userIsProfessional = ['CedLabProfessional', 'CedLabPowerUser'].includes(this.userRole);
    if (!this.userRole) { throw new Error('User role is unknown'); }

    this.tableInfoExists = this.infoService.isThereInfo(this.TABLE_TITLE);
  }

  private async getRecords() {
    this.dataStatus.resetStatus();
    this.loader.show();

    const result = await this.service.get(1, 10, this.sortingFilter, this.sortingAscending)
      .catch(error => {
        console.log('ERROR IN HOME -> SOTTO 100 -> GET', error);
        this.dataStatus
          .setStatus('failure')
          .setAlertMessage('Errore nel caricamento dei dati')
          .setAlertClasses(['cedlab-danger']);
        this.loader.hide();
      });
    if (!result) { return; }

    if (result.totalRecords > 0) {
      this.records = result.records;
      this.dataStatus.setStatus('success');
    } else {
      this.records = [];
      this.dataStatus
        .setStatus('info')
        .setAlertMessage('Nessun isin presente')
        .setAlertClasses(['cedlab-info']);
    }
    this.loader.hide();
  }

  private async getRecordsForGuest() {
    this.dataStatus.resetStatus();
    this.loader.show();

    const result = await this.service.getForGuests()
      .catch(error => {
        console.log('ERROR IN HOME -> SOTTO 100 -> GET', error);
        this.loader.hide();
        this.dataStatus
          .setStatus('failure')
          .setAlertMessage('Errore nel caricamento dei dati')
          .setAlertClasses(['cedlab-danger']);
      });
    if (!result) { return; }

    if (result.totalRecords > 0) {
      this.records = result.records;
      this.dataStatus.setStatus('success');
    } else {
      this.records = [];
      this.dataStatus
        .setStatus('info')
        .setAlertMessage('Nessun isin presente')
        .setAlertClasses(['cedlab-info']);
    }
    this.loader.hide();
  }

  public triggerSorting({ active, direction }) {

    if (this.userIsGuest()) { return; }

    this.sortingFilter = active;
    switch (direction) {
      case 'asc':
        this.sortingAscending = true;
        break;
      case 'desc':
        this.sortingAscending = false;
        break;
      default: this.sortingAscending = null;
    }

    this.getRecords().then();
  }

  public addIsinToWatchlist(isin: string) {
    if (this.userIsGuest()) {
      this.dialogService.openFailureSnackBar('Abbonati ai servizi CedLab per usufruire dell\'esperienza completa');
      return;
    }

    this.addToWatchlistManager.addToWatchlist(isin);
  }

  private userIsGuest = () => this.userRole === 'CedLabGuest';
  public openInfoDialog() {
    const tableInfo = this.infoService.getTableInfo(this.TABLE_TITLE);
    this.dialogService.openTableInfoDialog(tableInfo);
  }

  public async downloadExcel() {
    this.downloadExcelLoader.show();
    await this.service.downloadExcel(50).then(
      response => {
        const currentDate = new Date();
        const fileName = 'Sotto100Top50_' + (currentDate.getMonth() + 1) + '_' + currentDate.getFullYear();
        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(response);
        a.href = objectUrl;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(objectUrl);
      }).catch(_ => {
          this.dialogService.openFailureSnackBar('Errore nel download');
        });
    this.downloadExcelLoader.hide();
  }

  toggle() {
    this.state = this.state === 'collapsed' ? 'expanded' : 'collapsed';
    if (this.state === 'expanded') {
      if (this.userIsGuest()) {
        this.getRecordsForGuest().then();
      } else {
        this.getRecords().then();
      }
    }
  }
}
